import { WhmBox, WhmContainer } from "@securitize/reactjs-whm";
import UserProvider from "../../contexts/UserContext";
import Portfolio from "../../components/Portfolio";
import { MOCK_USER_INFO } from "../mockUserInfo";

export default function PortfolioView() {
  return (
    <WhmContainer>
      <WhmBox>
        <UserProvider userInfo={MOCK_USER_INFO}>
          <Portfolio />
        </UserProvider>
      </WhmBox>
    </WhmContainer>
  );
}
